import {$authHost, $host} from "./index";
import {API_ENDPOINTS, URLS} from "../utils/urls";




export async function calculationGetByIdAPI(
    calcId: string | number,
){
    try {
        return await $authHost.get(API_ENDPOINTS.CALCULATION + '/' + `${calcId}` );

    } catch (error: any) {
        return error;
    }
}

export type CalcCounts = {
    calcAll: number,
    calcPaid: number,
    calcNotPaid: number,
    calcPending: number,
};

export async function calculationGetCountsAPI(
    companyId: string | 'all',
    payee: string | 'all' = 'all',
){
    try {
        return await $authHost.get(
            API_ENDPOINTS.CALCULATION + '/counts?company=' + companyId + '&payee=' + payee
        );

    } catch (error: any) {
        return error;
    }
}

export async function calculationGetAPI(
    companyId: string | 'all',
    queryParam: 'calcAll' | 'calcPaid' | 'calcNotPaid' | 'calcPending',
    payee: string | 'all' = 'all',
){
    try {
        return await $authHost.get(
            API_ENDPOINTS.CALCULATION + '?type=' + queryParam + '&company=' + companyId + '&payee=' + payee
        );

    } catch (error: any) {
        return error;
    }
}

// Look up a closed calculation by its invoice number, optionally scoped to
// the payee it was issued from ('all' = any). Returns an array of matches
// (most-recent first) — used by the "Активные счета" search box on Main.
export async function calculationSearchAPI(
    invoice: string | number,
    payee: string | number = 'all',
){
    try {
        return await $authHost.get(
            API_ENDPOINTS.CALCULATION + `/search?invoice=${encodeURIComponent(`${invoice}`)}&payee=${payee}`
        );

    } catch (error: any) {
        return error;
    }
}

export async function calculationPostAPI(data: any, companyId: string | undefined, userId: string){
    try {
        if (companyId) {
            return await $authHost.post(API_ENDPOINTS.CALCULATION + '/' + companyId + '?userId=' + userId, data);
        }

    } catch (error: any) {
        return error;
    }
}

export async function calculationUpdateStatusAPI(
    calcId: string | number | undefined,
    status: 'paid' | 'notPaid',
    userId: string | number
){
    try {
        if (calcId) {
            return await $authHost.put(API_ENDPOINTS.CALCULATION + `?calcId=${calcId}&status=${status}&userId=${userId}`);
        }

    } catch (error: any) {
        return error;
    }
}

export async function calculationUpdateTbDataAPI(calcId: string | number | undefined, data: any){
    try {
        if (calcId) {
            return await $authHost.put(API_ENDPOINTS.CALCULATION + `/${calcId}`, data);
        }

    } catch (error: any) {
        return error;
    }
}

export async function calculationDeleteAPI(companyId: string | number | undefined){
    try {
        if (companyId) {
            return await $authHost.delete(API_ENDPOINTS.CALCULATION + '/' + companyId);
        }

    } catch (error: any) {
        return error;
    }
}

